import React from "react"
import { IconMenu, IconButton, FontIcon, MenuItem } from "material-ui"
import strings from "../../../localization/strings"
import { EAccrualType, IUserDocument } from "../../../models"
import { CSVLink } from "react-csv"
import AccountStore from "../../../stores/AccountStore"
import * as utils from "../../../helpers/utils"
import * as timeHelper from "../../../helpers/timeHelper"
import moment from "moment"

interface IProps {
    user: IUserDocument
}
interface IState {
    open: boolean
}

export default class UserDetailAccrualsReport extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            open: false
        }
    }

    getDownloadData() {
        const downloadData = [
            [
                strings.Accrual_Name,
                strings.Accrual_Type,
                strings.Starting_Balance,
                strings.Current_Balance,
                strings.Pending_Balance,
                strings.Start_Date,
                strings.Probation_End_Date,
                strings.Use_for_Leave_Tracking,
                strings.Active,
                // audits
                strings.Name,
                strings.Date,
                strings.Note,
                strings.Accrual_Used,
                strings.Accrual_Earned
            ]
        ]
        const accruals = this.props.user.Accruals.filter(i => !i.Deleted)
        accruals.forEach(accrual => {
            const audits = accrual.ChangeAudits.reverse()
            const accountAccrual = AccountStore.getCurrentAccount().Accruals.find(i => i.Id === accrual.LinkedAccountAccrualId)
            const accrualType = accountAccrual.Type === EAccrualType.PerHourWorked ? strings.Per_Hour_Worked : strings.Per_Day
            downloadData.push(
                [
                    accrual.Name,
                    accrualType,
                    utils.roundToTwo(accrual.StartingBalance).toString(),
                    utils.roundToTwo(accrual.Balance).toString(),
                    utils.roundToTwo(accrual.PendingBalance).toString(),
                    moment(timeHelper.keepConvertUTCToLocal(accrual.AccrualStartDate)).format("MM/DD/YYYY"),
                    accrual.AllowUseForLeaveTracking && accrual.EnableProbationDate ? moment(timeHelper.keepConvertUTCToLocal(accrual.AccrualEndProbationDate)).format("MM/DD/YYYY") : "",
                    accrual.AllowUseForLeaveTracking ? strings.Yes : strings.No,
                    accrual.Active ? strings.Active : strings.Inactive,
                    audits.length > 0 ? audits[0].NameOfChangingUser : "",
                    audits.length > 0 ? moment(audits[0].DateTimeOfChange).format("YYYY-MM-DD HH:mm") : "",
                    audits.length > 0 ? audits[0].ChangeNote : "",
                    audits.length > 0 && audits[0].DiffBalance < 0 ? (-audits[0].DiffBalance).toString() : "",
                    audits.length > 0 && audits[0].DiffBalance > 0 ? (audits[0].DiffBalance).toString() : ""
                ]
            )
            if (audits.length > 1) {
                for (let i = 1; i < audits.length; i++) {
                    downloadData.push(
                        [
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            "",
                            audits.length > 0 ? audits[i].NameOfChangingUser : "",
                            audits.length > 0 ? moment(audits[i].DateTimeOfChange).format("YYYY-MM-DD HH:mm") : "",
                            audits.length > 0 ? audits[i].ChangeNote : "",
                            audits.length > 0 && audits[i].DiffBalance < 0 ? (-audits[i].DiffBalance).toString() : "",
                            audits.length > 0 && audits[i].DiffBalance > 0 ? (audits[i].DiffBalance).toString() : ""
                        ]
                    )
                }
            }
        })
        return downloadData
    }

    render() {
        const downloadData = this.getDownloadData()
        return (
            <div style={{ marginTop: -10, marginLeft: 5 }}>
                <IconMenu
                    open={this.state.open}
                    style={{ padding: 0 }}
                    iconButtonElement={
                        <IconButton data-intercom-target={"Employee-Detail-Accrual-Reports"} tooltip={strings.Reports}>
                            <FontIcon className="fa fa-file-text itemActionButton" style={{ fontSize: 20 }} />
                        </IconButton>
                    }
                    anchorOrigin={{ horizontal: 'right', vertical: 'top' }}
                    targetOrigin={{ horizontal: 'right', vertical: 'top' }}
                    onClick={() => this.setState({ open: !this.state.open })}
                >
                    <CSVLink
                        key="csvlink"
                        data={downloadData}
                        style={{ textDecoration: "none" }}
                        filename={`${this.props.user.FirstName}_${this.props.user.LastName}_${this.props.user.ExternalId}_Accrual_Report_${moment().format("YYYY-MM-DD")}.csv`}
                    >
                        <MenuItem
                            data-intercom-target={"Employee-Page-Report-Download"}
                            primaryText={strings.Accrual_Balance_Report}
                            leftIcon={<FontIcon className="fa fa-file-excel-o" />}
                            onClick={() => this.setState({ open: false })}
                        />
                    </CSVLink>
                </IconMenu>
            </div>
        )
    }
}